window.onload = function () {
  const carousel = window.neptune.flickity.carousels[0];

  let previousCarouselIndex = carousel.selectedIndex;

  /**
   * Flickity listener
   * Handles swipes, arrows, variant changes, or any external carousel movement
   */
  carousel.on("select", function () {
    const currentIndex = carousel.selectedIndex;

    const direction = currentIndex - previousCarouselIndex;

    if (!direction) {
      return;
    }

    movePillControls(direction);

    previousCarouselIndex = currentIndex;
  });

  /**
   * Handles clicking the pill controls
   */
  window.pillCarouselNavigate = function (button) {
    const container = button.closest(".carousel-pill-buttons");

    const buttons = [...container.querySelectorAll(".carousel-pill-button")];

    const activeButton = container.querySelector(
      ".carousel-pill-button.active",
    );

    const activeIndex = buttons.indexOf(activeButton);
    const clickedIndex = buttons.indexOf(button);

    const direction = clickedIndex - activeIndex;

    if (!direction) {
      return;
    }

    carousel.select(carousel.selectedIndex + direction);
  };

  /**
   * Moves the pill control track one position
   */
  function movePillControls(direction) {
    const container = document.querySelector(".carousel-pill-buttons");
    const track = container.querySelector(".carousel-pill-buttons-track");

    const distance = 34 * direction;

    if (direction > 0) {
      // Moving right - add replacement dot on the right
      const newButton = document.createElement("button");

      newButton.className = "carousel-pill-button";
      newButton.setAttribute("onclick", "pillCarouselNavigate(this)");

      track.appendChild(newButton);

      track.style.transform = `translateX(-${distance}px)`;

      track.addEventListener("transitionend", function moveRightComplete() {
        track.removeEventListener("transitionend", moveRightComplete);

        track.firstElementChild.remove();

        resetPillTrack(track);
      });
    } else {
      // Moving left - add replacement dot on the left
      const newButton = document.createElement("button");

      newButton.className = "carousel-pill-button";
      newButton.setAttribute("onclick", "pillCarouselNavigate(this)");

      track.insertBefore(newButton, track.firstElementChild);

      track.style.transition = "none";
      track.style.transform = `translateX(-${Math.abs(distance)}px)`;

      track.offsetHeight;

      track.style.transition =
        "transform 400ms cubic-bezier(0.25, 0.1, 0.25, 1)";

      track.style.transform = "translateX(0)";

      track.addEventListener("transitionend", function moveLeftComplete() {
        track.removeEventListener("transitionend", moveLeftComplete);

        track.lastElementChild.remove();

        resetPillTrack(track);
      });
    }
  }

  /**
   * Keeps the active pill centred
   */
  function resetPillTrack(track) {
    const buttons = [...track.querySelectorAll(".carousel-pill-button")];

    buttons.forEach((button) => {
      button.classList.remove("active");
    });

    // Middle button is always the active pill
    buttons[2].classList.add("active");

    // Reset track position
    track.style.transition = "none";
    track.style.transform = "translateX(0)";

    track.offsetHeight;

    track.style.transition = "transform 400ms cubic-bezier(0.25, 0.1, 0.25, 1)";
  }
};
